import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { JobOverviewModel } from '../state/job-overview.model';

export type ActiveJobOverviewModel = Observable<JobOverviewModel>;

export const ACTIVE_JOB_OVERVIEW_MODEL = new InjectionToken<ActiveJobOverviewModel>(
  'Job Overview Models (Datasource Table/Export Trigger)',
);
